// START IMPORTS
import { constants } from '../../appConstants';
// END IMPORTS

// START CONSTANTS
const contactProLink =
  'https://www.beenverified.com/rf/search/contact?advancedSearch=true&source=contactSearch';
const unclaimedMoneyLink =
  'https://www.beenverified.com/rf/dashboard/unclaimed-money';
const memberPerksLink = 'https://www.beenverified.com/rf/dashboard/rewards';
const testimonialsLink = 'https://www.beenverified.com/reviews/';
const pressLink = 'https://www.beenverified.com/press/';
const careersLink = 'https://www.ltvco.com/careers/';
const forBusinessLink = 'https://business.beenverified.com';
// END CONSTANTS

// START HELPER_FUNCTIONS
export const generateFooterLinks = ({
  contactUsHandler,
  requestApiAccessHandler,
  needMoreReportsHandler,
  isInternationalTestUser,
}: {
  contactUsHandler: () => void;
  requestApiAccessHandler: (e?: { preventDefault?: () => void }) => void;
  needMoreReportsHandler: (e?: { preventDefault?: () => void }) => void;
  isInternationalTestUser?: boolean;
}) => {
  const {
    links: { affiliateLink, aboutLink, doDontsLink, FaqLink, supportLink },
  } = constants;

  const dosAndDontsLink = { text: "Do's & Dont's", href: doDontsLink };

  const supportLinks = [
    { text: 'Customer Care', href: supportLink },
    { text: 'Contact Us', href: '#', onClick: contactUsHandler },
    dosAndDontsLink,
    { text: "FAQ's", href: FaqLink },
  ];

  const commonSections = [
    ...(supportLinks.length > 0
      ? [
          {
            title: 'SUPPORT',
            links: supportLinks,
          },
        ]
      : []),
    {
      title: 'COMPANY',
      links: [
        { text: 'About BeenVerified', href: aboutLink },
        { text: 'For Business', href: forBusinessLink },
        { text: 'Testimonials', href: testimonialsLink },
        { text: 'Press', href: pressLink },
        { text: 'Careers', href: careersLink },
      ],
    },
  ];

  if (isInternationalTestUser) {
    return [
      {
        title: 'RESOURCES',
        links: [{ text: 'Affiliates', href: affiliateLink }],
      },
      ...commonSections,
    ];
  }

  return [
    {
      title: 'MORE SEARCHES',
      links: [
        { text: 'Contact Pro', href: contactProLink },
        { text: 'Unclaimed Money', href: unclaimedMoneyLink },
      ],
    },
    {
      title: 'RESOURCES',
      links: [
        { text: 'Affiliates', href: affiliateLink },
        { text: 'Member Perks', href: memberPerksLink },
        {
          text: 'Request API Access',
          href: '#',
          onClick: requestApiAccessHandler,
        },
        {
          text: 'Need More Reports?',
          href: '#',
          onClick: needMoreReportsHandler,
        },
      ],
    },
    ...commonSections,
  ];
};
// END HELPER_FUNCTIONS
